import { render, staticRenderFns } from "./DefaultCertificateCard.vue?vue&type=template&id=19822644&scoped=true&"
import script from "./DefaultCertificateCard.vue?vue&type=script&lang=js&"
export * from "./DefaultCertificateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19822644",
  null
  
)

export default component.exports